import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import confirmService from '../services/confirm.service'
import alertService from '../services/alert.service'
import itemService from '../services/item.service'
import itemApi, { ItemData } from '../apis/item.api'
import { ItemType } from '../apis/ItemType.api'
import customLabelApi, {
  CustomLabelUpdateRequest
} from '../apis/customLabel.api'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import InputFile from '../components/InputFile'

interface RouteState {
  id: number
}

interface Props extends RouteComponentProps<any, any, RouteState> {}

interface State {
  name: string
  item: string
  csvFilename: string
  apiUrl: string
  itemId: number | null
  items: ItemData[]
  csv: File | null
}

class CustomLabelEditForm extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      name: '',
      item: '',
      csvFilename: '',
      apiUrl: '',
      itemId: null,
      csv: null,
      items: []
    }
  }

  get id () {
    return this.props.location.state.id
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  handleInputChange = (name: string, value: string) => {
    if (name === 'name') this.setState({ name: value })
    else if (name === 'item') this.setState({ item: value })
    else if (name === 'apiUrl') this.setState({ apiUrl: value })
  }

  handleItemSearch = (name: string, term: string) => {
    const types: ItemType[] = ['production', 'receivable']
    itemApi.searchByCode(term, types, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleItemBlur = () => {
    this.setState({ items: [] })
  }

  handleItemSelect = (name: string, option: SearchPickerOption) => {
    const { value } = option
    const itemId = option.id as number
    const item = itemService.find(this.state.items, itemId)
    if (!item) return
    this.setState({ items: [], item: value, itemId })
  }

  handleFileChange = (name: string, file: File | null, filename: string) => {
    if (name === 'csv') {
      this.setState({
        csv: file,
        csvFilename: filename
      })
    }
  }

  handleSaveConfirm = () => {
    const { name, csv, csvFilename, apiUrl, itemId } = this.state
    const payload: CustomLabelUpdateRequest = {}
    if (name) payload.name = name
    if (csv) payload.csv = csv
    if (csvFilename) payload.csvFilename = csvFilename
    if (apiUrl) payload.apiUrl = apiUrl
    if (itemId) payload.item = itemId
    customLabelApi.update(this.id, payload, customLabel => {
      if (!customLabel) return
      alertService.success('Successfully updated custom label')
    })
  }

  handleSaveClick = () => {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review custom label details above and then confirm'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.handleSaveConfirm()
    }
    confirmService.push(confirm)
  }

  read = () => {
    customLabelApi.read(this.id, customLabel => {
      if (!customLabel) return
      const { name, item } = customLabel
      this.setState({ name }, () => {
        if (!item) return
        this.setState({
          itemId: item.id,
          item: item.code
        })
      })
    })
  }

  componentDidMount () {
    this.read()
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Edit Custom Label")} />
        <Row column={2}>
          <InputText
            name="name"
            value={this.state.name}
            label={i18n("Name")}
            onChange={this.handleInputChange} />
          <SearchPicker
            name="item"
            value={this.state.item}
            options={this.itemSearchOptions}
            label={i18n("Item code")}
            onSearch={this.handleItemSearch}
            onChange={this.handleInputChange}
            onSelect={this.handleItemSelect}
            onBlur={this.handleItemBlur} />
          <InputFile
            className="mb-0"
            name="csv"
            filename={this.state.csvFilename}
            accept=".csv"
            label="CSV"
            placeholder="Choose csv"
            onChange={this.handleFileChange} />
          <InputText
            name="apiUrl"
            value={this.state.apiUrl}
            label={i18n("API URL")}
            onChange={this.handleInputChange} />
        </Row>
        <CardButton
          proceedText={i18n("Save")}
          cancelText={i18n("Cancel")}
          onProceedClick={this.handleSaveClick} />
      </Card>
    )
  }
}

export default withRouter(CustomLabelEditForm)
